export const goodflipImgUrls = {
  successImage: require('../assets/images/goodflip-success.webp'),
}
